import { useEffect, useRef } from "react";

export default function Cursor() {
  const dot = useRef(null);
  const ring = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(pointer: coarse)").matches) return;

    document.body.classList.add("cursor-hidden");
    let x = -100, y = -100, rx = -100, ry = -100, raf = 0;

    const move = (e) => {
      x = e.clientX;
      y = e.clientY;
      if (dot.current) dot.current.style.transform = `translate(${x}px, ${y}px)`;
    };
    const loop = () => {
      rx += (x - rx) * 0.18;
      ry += (y - ry) * 0.18;
      if (ring.current) ring.current.style.transform = `translate(${rx}px, ${ry}px)`;
      raf = requestAnimationFrame(loop);
    };
    const over = (e) => {
      const hit = e.target.closest(
        "a, button, [role=button], input, textarea, select, [data-cursor=hover]"
      );
      if (ring.current) ring.current.classList.toggle("cursor-ring--active", !!hit);
    };

    raf = requestAnimationFrame(loop);
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerover", over);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerover", over);
      document.body.classList.remove("cursor-hidden");
    };
  }, []);

  return (
    <>
      <div ref={ring} className="toji-cursor-ring" aria-hidden="true" />
      <div ref={dot} className="toji-cursor-dot" aria-hidden="true" />
    </>
  );
}
